import { AppenateCreateUserModel } from "../models/appenate-createuser.model";

export class ContractorDetailsModel {
  tblContractorId: number = 0;
  ClientId: number = 0;
  FormId: string = "";
  contractorCode: string = "";
  contractorName: string = "";
  contactPersonName: string = "";
  contractorTelephone1: string = "";
  contractorTelephone2: string = "";
  contractorEmail: string = "";
  contractorWebsite: string = "";
  contractorLogo: string = "";
  webLogin: string = "No";
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  isActive: boolean = true;
  createdOnUtc: Date = new Date();
  createdBy: string = "";
  updatedOnUtc: Date = new Date();
  updatedBy: string = "";
  userId: string = "";
  autoGenerateCode: boolean = true;
  appenateUser: string = "No";
  appenateUserId: string = "";
  reportEmail: string = "";
}


export class ContractorConfigurationModel {
  formId: string = "";
  formTitle: string = "Contractor";
  addFormName: string = "Add Contractor";
  editFormName: string = "Edit Contractor";
  listReportFormName: string = "Contractors";
  pkTableId: string = "";
  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  allowInvoice:boolean=false;
  displayListCardView: boolean = false;
  autoGenerateContractorCode: boolean = true;
  requiredFeilds: RequiredContractorFeilds = { contractorCode: true, contractorName: true, contactPersonName: true, contractorTelephone1: true, contractorTelephone2: true, contractorEmail: false, contractorWebsite: true, contractorLogo: true, webLogin: true, appenateUser: false  };;
  allowedFields: AllowedContractorFeilds = { contractorCode: true, contractorName: true, contactPersonName: true, contractorTelephone1: true, contractorTelephone2: true, contractorEmail: true, contractorWebsite: true, contractorLogo: true, webLogin: true, appenateUser: false  };

  displayContractorDropDownList: boolean = false; //display only contractor dropdown list
  selectedValueContractorDropDownList: string = "0";

  contractorRoles: any = [];
  fieldsTitle: FieldsTitle = new FieldsTitle();
  fieldsFormat: FieldsFormat = new FieldsFormat();
  selectContractorSection: boolean = false;
  //AppenateFields
  appenateCreateUser: AppenateCreateUserModel = new AppenateCreateUserModel();
}

export class AllowedContractorFeilds {
  contractorCode: boolean = false;
  contractorName: boolean = true;
  contactPersonName: boolean = true;
  contractorTelephone1: boolean = true;
  contractorTelephone2: boolean = true;
  contractorEmail: boolean = true;
  contractorWebsite: boolean = true;
  contractorLogo: boolean = true;
  webLogin: boolean = true;
  appenateUser: boolean = false;
}

export class FieldsTitle {
  telephone1: string = "Telephone 1";
  telephone2: string = "Telephone 2";
}

export class FieldsFormat {
  telephone1: string = "";
  telephone2: string = "";
}
export class RequiredContractorFeilds {
  contractorCode: boolean = false;
  contractorName: boolean = true;
  contactPersonName: boolean = true;
  contractorTelephone1: boolean = true;
  contractorTelephone2: boolean = true;
  contractorEmail: boolean = true;
  contractorWebsite: boolean = true;
  contractorLogo: boolean = true;
  webLogin: boolean = true;
  appenateUser: boolean = false;
}

export class ValidationModel {

  isContractorCodeValid: boolean = true;
  ContractorCodeValidationMessage: string = "Contractor Code is required";

  isContractorNameValid: boolean = true;
  ContractorNameValidationMessage: string = "Contractor Name is required";


  isContactPersonNameValid: boolean = true;
  ContactPersonNameValidationMessage: string = "Contact Person Name is required";

  isContractorTelephone1Valid: boolean = true;
  ContractorTelephone1ValidationMessage: string = "Telephone1 is required";

  isContractorTelephone2Valid: boolean = true;
  ContractorTelephone2ValidationMessage: string = "Telephone2 is required";

  isContractorLogoValid: boolean = true;
  ContractorLogoValidationMessage: string = "Contractor Logo is required";

}



